import middlewareConfig from "./middleware-config";
import { MIDDLEWARE_ENUMS } from "./middleware-constants";

const suggestionApi = (api) => {

    const fetchPlaceSuggestions = (params) => {
        return api.get(`/get-autosuggest`, { params });
    };

    const fetchReverseGeoCodeSuggestions = (params) => {
        return api.get(`/get-reverse-geocode`, { params });
    };

    const fetchPlaceDetails = (params) => {
        return api.get(`/get-place-detail`, { params });
    };

    return {
        fetchPlaceSuggestions,
        fetchReverseGeoCodeSuggestions,
        fetchPlaceDetails
    };
};

export const SuggestionService = suggestionApi(middlewareConfig(MIDDLEWARE_ENUMS.BASE_CONST));

